import { render, staticRenderFns } from "./SafetyHandleDialog.vue?vue&type=template&id=4163c98f&scoped=true"
import script from "./SafetyHandleDialog.vue?vue&type=script&lang=ts"
export * from "./SafetyHandleDialog.vue?vue&type=script&lang=ts"
import style0 from "./SafetyHandleDialog.vue?vue&type=style&index=0&id=4163c98f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163c98f",
  null
  
)

export default component.exports